import { useEffect, useState } from "react";
import { Radio, RadioChangeEvent } from 'antd';

// Internal Imports
import { useForm } from "../../contexts/form";
import LoadingButton from "../../common/components/LoadingButton/LoadingButton";
import ModalBtnCotainer from "../../common/components/ModalBtnContainer/ModalBtnContainer";
import ModalContainer from "../../common/components/ModalContainer/ModalContainer";
import RelatedQuestion from "../../common/components/RelatedQuestion/RelatedQuestion";
import { COLORS } from "../../common/constants/colors";
import { getError, openNotification, tryCatch } from "../../common/constants/Utilities";
import { IForm, IFormQuestion } from "../../interfaces/IForm";
import { IResponse } from "../../interfaces/IResponse";
import { getQuestionsByFormID, UpdateRelatedQuestionByFormID } from "../../services/form";
import { PreguntaTipo } from "../../common/enums/AllEnums";

interface Props {
    setRelateQuestionModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const RelacionarPreguntas = ({ setRelateQuestionModal }: Props) => {

    // States
    const { formQuestion } = useForm();
    const [questionSelected, setQuestionSelected] = useState<number | null>(null);
    const [listQuestion, setListQuestion] = useState<IFormQuestion[]>([]);
    const [formLoading, setFormLoading] = useState<boolean>(false);

    // handles

    const hadleRadioChange = (e: RadioChangeEvent) => {
        const position = e.target.value;
        const internalList = listQuestion;

        for(let i = 0; i < internalList.length; i++){
            internalList[i].esPrincipal = false
        }

        /*if (questionSelected !== null) {
            internalList[questionSelected].esPrincipal = false;
        }*/

        internalList[position].esPrincipal = true;
        setQuestionSelected(position);
        setListQuestion([...internalList]);
    };


    const handleSetQuestionNext = (index: number, question: IFormQuestion) => {
        const listClone = listQuestion;
        listClone[index] = question;
        setListQuestion([...listClone]);
    }

    const isQuestionListReadyToBeSend = (questionList: IFormQuestion[]) => {

        /////////
        let existNextInMainQuestion = false;
        questionList.find(question => question.esPrincipal)?.respuestaOpcion.forEach(option => {
            if (!!option.preguntaSiguienteID) {
                existNextInMainQuestion = true;
            }
        });
        if (!existNextInMainQuestion) {
            openNotification('error', 'Error', 'La (Pregunta Principal) debe tener al menos una (Pregunta Siguiente)');
            return false;
        }
        /////////

        /////////
        let existNull = false;
        let existNext = false;

        questionList.forEach(question => {
            for (let i = 0; i < question.respuestaOpcion.length; i++) {
                if (!question.respuestaOpcion[i].preguntaSiguienteID) {
                    existNull = true;
                } else {
                    existNext = true;
                }
            }
        })

        if (!existNext) {
            openNotification('error', 'Error', 'Al menos una pregunta debe tener una (Pregunta Siguiente)');
            return false;
        }

        if (!existNull) {
            openNotification('error', 'Error', 'Una de las (Preguntas Siguiente) debe estar (Vacia)');
            return false;
        }
        /////////

        return true;

    }

    const handleSubmit = () => {
        const isReady = isQuestionListReadyToBeSend(listQuestion);
        if (isReady) {
            tryCatch(() => {
                setFormLoading(true);
                UpdateRelatedQuestionByFormID(formQuestion?.formularioID!, listQuestion)
                    .then((response) => {
                        openNotification('success', `Las preguntas del formulario (${formQuestion!.nombre}) has sido relacionadas.`, response.msg!);
                        setRelateQuestionModal(false);
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setFormLoading(false));
            })
        }
    }

    // Methods
    const getListOrderQuestion = (questionId: number) => {
        return listQuestion.map(item => item.preguntaID).filter(item => item !== questionId);
    }

    // Effects
    useEffect(() => {
        tryCatch(() => {
            getQuestionsByFormID(formQuestion?.formularioID!)
                .then((response) => {
                    //Ordena las preguntas antes de mandarlas a setListQuestion
                    response.data.sort((a: { orden: number; }, b: { orden: number; }) => a.orden - b.orden);
                    
                    setListQuestion(response.data);
                    const principal = response.data.findIndex((question: IFormQuestion) => question.esPrincipal);
                    if (principal !== -1) {
                        setQuestionSelected(principal);
                    }
                })
        })
    }, [])

    return (
        <ModalContainer style={{ height: '100vh' }}>
            <div style={{ paddingBottom: "20%" }}>
                <div className="stepper_title" style={{ marginTop: 5 }}>Preguntas</div>
                <div style={{ marginTop: 30, display: 'flex', justifyContent: 'center', flexDirection: 'column', minHeight: '50px' }}>
                    <Radio.Group onChange={hadleRadioChange} value={questionSelected}>
                        {listQuestion.map((question, index) => (
                            <RelatedQuestion
                                question={question}
                                loading={formLoading}
                                index={index}
                                method={handleSetQuestionNext}
                                orderList={getListOrderQuestion(question.preguntaID)}
                            />
                        ))}
                    </Radio.Group>
                </div>

                <ModalBtnCotainer>
                    <LoadingButton
                        type="button"
                        disabled={false}
                        method={handleSubmit}
                        title={"Guardar"}
                        loading={formLoading.toString()}
                        background={COLORS.blue_active}
                        color={COLORS.white_color1}
                        style={{ padding: '3px', width: '200px', margin: 'auto', height: '32px' }}
                        fontsize={16}
                    />
                </ModalBtnCotainer>
            </div>
        </ModalContainer>
    );
}


export default RelacionarPreguntas;